export default __webpack_public_path__ + "static/media/project-foodapp.adee2a4e.jpg";